import { render, staticRenderFns } from "./JournalEntries.vue?vue&type=template&id=6456fc2b&scoped=true&"
import script from "./JournalEntries.vue?vue&type=script&lang=js&"
export * from "./JournalEntries.vue?vue&type=script&lang=js&"
import style0 from "./JournalEntries.vue?vue&type=style&index=0&id=6456fc2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456fc2b",
  null
  
)

export default component.exports